import { CPRClient } from 'rcx_adapter';
import { ISendProblemReportParamsToCpr } from 'rcx_adapter/src/problemReport/types';

import { BaseModule } from './BaseModule';
import { ModuleBaseOption } from '../interfaces/module';

class OnSendToCpr extends BaseModule<ModuleBaseOption> {
    public start(): void {
        if (this.getIsInit()) {
            this.listenFromRCX();
        }
    }
    private listenFromRCX() {
        this.mRCXAdapter!.onSendToCpr((data: any) => {
            this.onSendToCpr(data);
        });
    }

    public async onSendToCpr(data: ISendProblemReportParamsToCpr) {
        CPRClient.instance().sendAttachmentToCpr(data);
    }
}

export default new OnSendToCpr();
